import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {HttpService} from "../http.service";
import {ContactRequestModel} from "../../shared/model/request/createContactRequet.model";
import {ContactRequestFilterModel} from "../../shared/model/request/contact-request-filter.model";
import {HttpUtils} from "../../shared/utils/http.utils";

@Injectable({
  providedIn: 'root'
})
export class ContactRequestService {

  private urlV1 = environment.host + "/api/v1/contact-requests/"

  constructor(private http: HttpService) {
  }

  createContactRequest(requestBody: ContactRequestModel, eventId: number): Observable<any> {
    return this.http.post(this.urlV1 + eventId, requestBody);
  }

  answerContactRequest(contactRequestId: number, answer: boolean): Observable<any> {
    return this.http.patch(this.urlV1 + contactRequestId + '?answer=' + answer, null, {shouldShowLoading: true});
  }

  getEventUserContactRequest(eventId: number): Observable<any> {
    return this.http.get(this.urlV1 + "user/" + eventId)
  }

  getAll(page: number = 0, filters: ContactRequestFilterModel): Observable<any> {

    let params = HttpUtils.convertObjectToParam(filters)
      .append("page",page)

    return this.http.get(this.urlV1, {params, shouldShowLoading: true});
  }

  removeContactRequest(contactRequestId: number): Observable<any> {
    return this.http.delete(this.urlV1 + contactRequestId);
  }
}
